<div class="p-4" [formGroup]="parentForm">
  <h2 class="text-xl font-semibold mb-4">Materials Needed for Order:</h2>
  <div class="overflow-x-auto">
    <ng-container *ngIf="materialsArray.length > 0">
      <table mat-table #table [dataSource]="dataSource" class="min-w-full bg-white rounded shadow">
        <!-- Qty -->
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef class="font-semibold">Qty</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <mat-form-field appearance="fill" class="w-24">
              <input matInput type="number" formControlName="quantity" />
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Description -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef class="font-semibold">Description</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <mat-form-field appearance="fill" class="w-48">
              <input matInput formControlName="description" />
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Category -->
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef class="font-semibold">Client OR Order</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <mat-form-field appearance="fill" class="w-32">
              <mat-select formControlName="category">
                <mat-option *ngFor="let cat of categories$ | async" [value]="cat.key">{{
                  cat.value
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Rec. Date -->
        <ng-container matColumnDef="recDate">
          <th mat-header-cell *matHeaderCellDef class="font-semibold">Rec. Date</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <mat-form-field appearance="fill" class="w-32">
              <input matInput [matDatepicker]="picker" formControlName="recDate" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- PO # -->
        <ng-container matColumnDef="poNo">
          <th mat-header-cell *matHeaderCellDef class="font-semibold">PO #</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <mat-form-field appearance="fill" class="w-24">
              <input matInput formControlName="poNo" />
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="font-semibold">Status</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <mat-form-field appearance="fill" class="w-32">
              <mat-select formControlName="status">
                <mat-option *ngFor="let status of statuses$ | async" [value]="status.key">{{
                  status.value
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Notes -->
        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef class="font-semibold">Notes</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <mat-form-field appearance="fill" class="w-48">
              <input matInput formControlName="notes" />
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Attachments -->
        <ng-container matColumnDef="attachments">
          <th mat-header-cell *matHeaderCellDef class="font-semibold">Attachments</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <button
              mat-flat-button
              color="secondary"
              class="!text-green-600"
              (click)="addAttachment(i)"
              *ngIf="!viewDisable"
            >
              ADD +
            </button>

            <button
              mat-flat-button
              color="secondary"
              class="!text-green-600"
              (click)="viewAttachments(i)"
              *ngIf="hasAttachments(i)"
            >
              <span [ngClass]="{ 'font-bold': hasUnsavedAttachments(i) }">{{
                hasUnsavedAttachments(i) ? 'View *' : 'View'
              }}</span>
            </button>
          </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <button
              mat-icon-button
              color="warn"
              (click)="removeMaterialRow(i)"
              *ngIf="materialsArray.length > 1 && !viewDisable"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; let i = index; columns: displayedColumns"
          [formGroup]="row"
        ></tr>
      </table>
    </ng-container>
  </div>

  <div class="flex justify-between items-center mt-4">
    <mat-checkbox formControlName="materialsReceived">Materials Received</mat-checkbox>
    <button
      mat-flat-button
      color="primary"
      class="bg-green-600 text-white px-8 py-2 rounded shadow hover:bg-green-700"
      (click)="addMaterialRow()"
      *ngIf="!viewDisable"
    >
      ADD +
    </button>
  </div>
</div>
